import { render, staticRenderFns } from "./KanbanColumn.vue?vue&type=template&id=474685f0&scoped=true"
import script from "./KanbanColumn.vue?vue&type=script&lang=js"
export * from "./KanbanColumn.vue?vue&type=script&lang=js"
import style0 from "./KanbanColumn.vue?vue&type=style&index=0&id=474685f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474685f0",
  null
  
)

export default component.exports